module.exports = __webpack_public_path__ + "ly.2178201b.svg";